import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { productosDormitorio } from '../../data/productos';

const ProductosDormitorio = () => {
  const [showMore, setShowMore] = useState(false);
  const [isHiding, setIsHiding] = useState(false);
  
  // Función para manejar el toggle y scroll
  const handleToggleMore = () => {
    if (showMore) {
      // Si estamos mostrando más y vamos a ocultar, iniciar scroll primero
      document.getElementById('dormitorio').scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
      
      // Iniciar animación de desvanecimiento después de un pequeño delay
      setTimeout(() => {
        setIsHiding(true);
      }, 200);
      
      // Ocultar productos después de que termine la animación
      setTimeout(() => {
        setShowMore(false);
        setIsHiding(false);
      }, 1000); // 200ms delay + 800ms animación
    } else {
      // Si vamos a mostrar más, solo cambiar el estado
      setShowMore(true);
    }
  };
  
  // Convertir el objeto a array y reordenar según especificaciones
  const productosArray = Object.entries(productosDormitorio);
  
  // Ordenar productos: Ropero Cali, Escritorio Gamer, Biblioteca Morita
  const productosOrdenados = productosArray.sort((a, b) => {
    const [idA] = a;
    const [idB] = b;
    
    // Ropero Cali primero
    if (idA === 'ropero_cali') return -1;
    if (idB === 'ropero_cali') return 1;
    
    // Escritorio Gamer segundo
    if (idA === 'escritorio_gamer') return -1;
    if (idB === 'escritorio_gamer') return 1;
    
    // Biblioteca Morita tercero
    if (idA === 'biblioteca_morita') return -1;
    if (idB === 'biblioteca_morita') return 1;
    
    return 0;
  });
  
  const productosIniciales = productosOrdenados.slice(0, 3);
  const productosAdicionales = productosOrdenados.slice(3);

  return (
    <section className="products-section bedroom-section" id="dormitorio">
      <div className="section-container">
        <h2 className="section-title">Dormitorio</h2>
        <p className="section-subtitle">Crea el dormitorio de tus sueños</p>
        {/* Productos iniciales (siempre visibles) */}
        <div className="products-grid">
          {productosIniciales.map(([productId, product]) => (
            <Link key={productId} to={`/producto/${productId}`} className="product-placeholder">
              <div 
                className="placeholder-image" 
                style={{backgroundImage: `url(${product.images[0]})`}}
              ></div>
              <div className="placeholder-content">
                <h3>{product.name}</h3>
                <p>{product.price}</p>
              </div>
            </Link>
          ))}
        </div>
        
        {/* Productos adicionales (condicionales) */}
        {showMore && (
          <div className={`additional-products ${isHiding ? 'hiding' : ''}`}>
            {productosAdicionales.map(([productId, product]) => (
              <Link key={productId} to={`/producto/${productId}`} className="product-placeholder">
                <div 
                  className="placeholder-image" 
                  style={{backgroundImage: `url(${product.images[0]})`}}
                ></div>
                <div className="placeholder-content">
                  <h3>{product.name}</h3>
                  <p>{product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
        
        {/* Botón Ver más/Ver menos */}
        {productosAdicionales.length > 0 && (
                      <div className="show-more-container">
              <button
                className="show-more-button"
                onClick={handleToggleMore}
              >
                {showMore ? 'Ver menos' : 'Ver más'}
              </button>
            </div>
        )}
      </div>
    </section>
  );
};

export default ProductosDormitorio;
